import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TextInput } from '@tremor/react';
import { toast } from 'react-hot-toast';
import PaparazzoLogo from '../../commons/images/svgs/paparazzo_logo_vertical.svg';
import ManzoniLogo from '../../commons/images/manzoni_logo.png';
import { useAuth } from '../../hooks/useAuth';
import './Login.css';

const Reset = () => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');

  const handleResetPassword = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Inserisci un indirizzo email valido');
      return;
    }

    try {
      const { error } = await resetPassword(email);
      
      if (error) {
        toast.error('Errore nell\'invio dell\'email di reset');
        console.error('Reset password error:', error);
      } else {
        toast.success('Email di reset inviata con successo. Controlla la tua casella di posta.');
      }
    } catch (err) {
      toast.error('Errore nell\'invio dell\'email di reset');
      console.error('Failed to reset password', err);
    }
  };

  return (
    <div className="login">
      <form className="form">
        <div className="form__header">
          <img
            src={PaparazzoLogo}
            alt="Paparazzo"
            className="app-logo"
            decoding="async"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26.835"
            height="22.215"
            viewBox="0 0 26.835 22.215"
          >
            <g
              id="Raggruppa_452"
              data-name="Raggruppa 452"
              transform="translate(-696.392 -178.392)"
            >
              <line
                id="Linea_45"
                data-name="Linea 45"
                x2="22.62"
                y2="18"
                transform="translate(698.5 180.5)"
                fill="none"
                stroke="#c8dbea"
                strokeLinecap="round"
                strokeWidth="3"
              />
              <line
                id="Linea_46"
                data-name="Linea 46"
                x2="18"
                y2="22.62"
                transform="translate(721.12 180.5) rotate(90)"
                fill="none"
                stroke="#c8dbea"
                strokeLinecap="round"
                strokeWidth="3"
              />
            </g>
          </svg>
          <img src={ManzoniLogo} alt="AMC Manzoni" className="user-logo" />
        </div>
        <div className="form__body">
          <span className="h1">Reimposta password</span>

          <TextInput
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            icon={undefined}
            error={false}
            errorMessage=""
            disabled={false}
            maxWidth="max-w-none"
            marginTop="mt-0"
          />

          <button className="cta" onClick={handleResetPassword}>
            Reimposta password
          </button>

          <div className="form__password-reset">
            <Link to="/login?v2" style={{ fontSize: '13px' }}>Torna alla pagina di login</Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Reset;